// import React, { useState, useEffect, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import { useAuth } from "../../auth/AuthContext";
// import {
//   Button,
//   Card,
//   CardHeader,
//   CardBody,
//   FormGroup,
//   Form,
//   Input,
//   Container,
//   Row,
//   Col,
//   ModalFooter,
//   Label,
//   Table,
//   CardFooter,
//   Pagination,
//   PaginationItem,
//   PaginationLink,
// } from "reactstrap";
// // core components
// import Header from "components/Headers/Header";
// import { api } from "../../config/middleware";
// import {
//   API_GETUNITS,
//   API_GETSERVICES,
//   API_ADDSERVICE,
//   API_GETPRODUCTS,
// } from "../../config/api";
// import { useSessionStore } from "../../stores/sessionStore";
// import Swal from "sweetalert2";
// import withReactContent from "sweetalert2-react-content";

// const AddPackage = () => {
//   const MySwal = withReactContent(Swal);

//   const orgId = useSessionStore((s) => s.profile?.orgId);

//   const navigate = useNavigate();
//   const { user } = useAuth();
//   const role = (
//     user?.role ||
//     localStorage.getItem("role") ||
//     "user"
//   ).toLowerCase();

//   const [logoFile, setLogoFile] = useState(null);
//   const [logoPreview, setLogoPreview] = useState("");

//   const onLogoChange = (e) => {
//     const file = e.target.files?.[0];
//     if (!file) return;
//     setLogoFile(file);
//     const objectUrl = URL.createObjectURL(file);
//     setLogoPreview(objectUrl);
//   };

//   // cleanup object URL เมื่อเปลี่ยนไฟล์หรือ unmount
//   useEffect(() => {
//     return () => {
//       if (logoPreview) URL.revokeObjectURL(logoPreview);
//     };
//   }, [logoPreview]);

//   // state ฟอร์มอย่างง่าย
//   const [form, setForm] = useState({
//     zoneId: "",
//     customerCode: "",
//     name: "",
//     qty: "",
//     price: "",
//     leadtime: "",
//     status: "pending",
//     users: "",
//     completion: 0,
//     days: [],
//     timeSlot: "",
//     packingColor: "#3B82F6",
//     customerType: "แพ็คเกจ",
//     unitId: "",
//     unitName: "",
//   });

//   const customerTypeOptions = [
//     {
//       value: "แพ็คเกจ",
//       label: "แพ็คเกจ",
//     },
//     {
//       value: "รายชิ้น",
//       label: "รายชิ้น",
//     },
//     {
//       value: "ชั่งกิโล",
//       label: "ชั่งกิโล",
//     },
//   ];

//   const handleCancelAddPackage = () => {
//     navigate("/manage-package");
//   };

//   // ===== ดึง “สินค้า” จาก API_GETPRODUCTS =====
//   const [products, setProducts] = useState([]);
//   const [prodLoading, setProdLoading] = useState(false);
//   const [prodError, setProdError] = useState("");
//   const [selected, setSelected] = useState(new Set()); // เก็บ checkbox ที่เลือก

//   useEffect(() => {
//     let alive = true;
//     const fetchProducts = async () => {
//       if (!orgId) return;
//       setProdLoading(true);
//       setProdError("");
//       try {
//         const res = await api.get(API_GETPRODUCTS, {
//           params: { ORGID: orgId },
//         });
//         // โครงสร้าง response: { statustext, message, data: [...] }
//         const arr = Array.isArray(res?.data?.data) ? res.data.data : [];
//         if (alive) setProducts(arr);
//       } catch (err) {
//         if (alive) setProdError(err?.message || "โหลดสินค้าล้มเหลว");
//       } finally {
//         if (alive) setProdLoading(false);
//       }
//     };
//     fetchProducts();
//     return () => {
//       alive = false;
//     };
//   }, [orgId]);

//   const toggleSelect = (id) =>
//     setSelected((prev) => {
//       const next = new Set(prev);
//       next.has(id) ? next.delete(id) : next.add(id);
//       return next;
//     });

//   const allChecked = products.length > 0 && selected.size === products.length;
//   const toggleAll = () =>
//     setSelected((prev) =>
//       prev.size === products.length
//         ? new Set()
//         : new Set(products.map((p) => p.pdId))
//     );

//   // ===== ดึง “หน่วย” จาก API_GETSERVICES =====
//   const [units, setUnits] = useState([]);
//   const [unitLoading, setUnitLoading] = useState(false);
//   const [unitError, setUnitError] = useState("");

//   useEffect(() => {
//     let alive = true;
//     const fetchUnits = async () => {
//       if (!orgId) return;
//       setUnitLoading(true);
//       setUnitError("");
//       try {
//         const res = await api.get(API_GETUNITS, {
//           params: { ORGID: orgId },
//         });
//         const arr = Array.isArray(res?.data?.data) ? res.data.data : [];
//         if (alive)
//           setUnits(arr.map((u) => ({ id: u.unitId, name: u.unitName })));
//       } catch (err) {
//         if (alive) setUnitError(err?.message || "โหลดหน่วยไม่สำเร็จ");
//       } finally {
//         if (alive) setUnitLoading(false);
//       }
//     };
//     fetchUnits();
//     return () => {
//       alive = false;
//     };
//   }, [orgId]);

//   // === ปุ่มเลือก “หน่วย” แบบเม็ดยา ===
//   const UnitChooser = () => {
//     if (unitError) return <div className="text-danger">{unitError}</div>;

//     return (
//       <div className="d-flex align-items-center flex-wrap">
//         {units.map((u) => {
//           const active = form.unitId === u.id;
//           return (
//             <Button
//               key={u.id}
//               type="button"
//               size="sm"
//               outline={!active}
//               color={active ? "primary" : "secondary"}
//               className="mr-2 mb-2 rounded-pill"
//               onClick={() =>
//                 setForm((s) => ({ ...s, unitId: u.id, unitName: u.name }))
//               }
//               aria-pressed={active}
//             >
//               {u.name}
//             </Button>
//           );
//         })}

//         {/* เก็บค่าไว้ตอน submit */}
//         <Input type="hidden" name="unitId" value={form.unitId || ""} />
//         <Input type="hidden" name="unitName" value={form.unitName || ""} />
//       </div>
//     );
//   };

//   const [submitting, setSubmitting] = useState(false);
//   const [submitError, setSubmitError] = useState("");

//   const handleSubmit = async () => {
//     try {
//       setSubmitting(true);
//       setSubmitError("");

//       // ตรวจขั้นต่ำ
//       if (!orgId) throw new Error("ไม่พบ ORGID");
//       if (!form.name?.trim()) throw new Error("กรุณากรอกชื่อแพ็คเกจ/บริการ");
//       if (!form.unitName) throw new Error("กรุณาเลือกหน่วย");

//       const payload = {
//         ORGID: orgId,
//         NAME: form.name?.trim(),
//         PRICE: Number(form.price || 0),
//         TYPE: form.customerType,
//         QTY: Number(form.qty || 0),
//         LEADTIME: Number(form.leadtime || 0),
//         UNIT: form.unitName,
//         PRODUCT: products.filter((p) => selected.has(p.pdId)),
//       };

//       await api.post(API_ADDSERVICE, payload);

//       await MySwal.fire({
//         icon: "success",
//         title: "บันทึกสำเร็จ",
//         timer: 1500,
//         showConfirmButton: false,
//       });

//       navigate("/manage-package");
//     } catch (err) {
//       setSubmitError(err?.message || "บันทึกไม่สำเร็จ");
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   const [currentPage, setCurrentPage] = useState(1);
//   const pageSize = 10;
//   const totalPages = Math.ceil(products.length / pageSize);

//   const paginatedProducts = products.slice(
//     (currentPage - 1) * pageSize,
//     currentPage * pageSize
//   );

//   const start = products.length ? (currentPage - 1) * pageSize + 1 : 0;
//   const end = Math.min(currentPage * pageSize, products.length);

//   return (
//     <>
//       <Header />
//       {/* Page content */}
//       <Container className="mt--7" fluid>
//         <Row>
//           <Col xs="12">
//             <Card className="bg-secondary shadow">
//               <CardHeader className="bg-white border-0">
//                 <Row className="align-items-center">
//                   <Col xs="8">
//                     <h6 className="mb-0">เพิ่มบริการ</h6>
//                   </Col>
//                 </Row>
//               </CardHeader>
//               <CardBody>
//                 <Form>
//                   <>
//                     <Row>
//                       <Col lg="12">
//                         <FormGroup>
//                           {customerTypeOptions.map((o) => {
//                             const active = form.customerType === o.value;
//                             return (
//                               <Button
//                                 key={o.value}
//                                 type="button"
//                                 size="sm"
//                                 outline={!active}
//                                 color={active ? "primary" : "secondary"}
//                                 className="mr-2 mb-2 rounded-pill"
//                                 onClick={() =>
//                                   setForm((s) => ({
//                                     ...s,
//                                     customerType: o.value,
//                                   }))
//                                 }
//                                 aria-pressed={active}
//                               >
//                                 {o.label}
//                               </Button>
//                             );
//                           })}
//                           <Input
//                             type="hidden"
//                             name="customerType"
//                             value={form.customerType}
//                           />
//                         </FormGroup>
//                       </Col>
//                     </Row>
//                     {form.customerType === "แพ็คเกจ" && (
//                       <>
//                         <Row>
//                           <Col lg="6">
//                             <FormGroup>
//                               <label
//                                 className="form-control-label"
//                                 htmlFor="input-last-name"
//                               >
//                                 ชื่อแพ็คเเกจ
//                               </label>
//                               <Input
//                                 className="form-control-alternative"
//                                 id="input-name"
//                                 type="text"
//                                 value={form.name}
//                                 onChange={(e) =>
//                                   setForm((s) => ({
//                                     ...s,
//                                     name: e.target.value,
//                                   }))
//                                 }
//                               />
//                             </FormGroup>
//                           </Col>
//                           <Col lg="6">
//                             <FormGroup>
//                               <label
//                                 className="form-control-label"
//                                 htmlFor="input-last-name"
//                               >
//                                 จำนวน
//                               </label>
//                               <Input
//                                 className="form-control-alternative"
//                                 id="input-qty"
//                                 type="number"
//                                 value={form.qty}
//                                 onChange={(e) =>
//                                   setForm((s) => ({
//                                     ...s,
//                                     qty: e.target.value,
//                                   }))
//                                 }
//                               />
//                             </FormGroup>
//                           </Col>
//                           <Col lg="6">
//                             <FormGroup>
//                               <label
//                                 className="form-control-label"
//                                 htmlFor="input-last-name"
//                               >
//                                 ราคา(บาท)
//                               </label>
//                               <Input
//                                 className="form-control-alternative"
//                                 id="input-price"
//                                 type="number"
//                                 value={form.price}
//                                 onChange={(e) =>
//                                   setForm((s) => ({
//                                     ...s,
//                                     price: e.target.value,
//                                   }))
//                                 }
//                               />
//                             </FormGroup>
//                           </Col>
//                           <Col lg="6">
//                             <FormGroup>
//                               <label
//                                 className="form-control-label"
//                                 htmlFor="input-last-name"
//                               >
//                                 ระยะเวลา(วัน)
//                               </label>
//                               <Input
//                                 className="form-control-alternative"
//                                 id="input-leadtime"
//                                 type="number"
//                                 value={form.leadtime}
//                                 onChange={(e) =>
//                                   setForm((s) => ({
//                                     ...s,
//                                     leadtime: e.target.value,
//                                   }))
//                                 }
//                               />
//                             </FormGroup>
//                           </Col>
//                         </Row>
//                         <Row>
//                           <Col lg="12">
//                             <label className="form-control-label">หน่วย</label>
//                             <FormGroup className="mb-0">
//                               <UnitChooser />
//                             </FormGroup>
//                           </Col>
//                         </Row>
//                       </>
//                     )}
//                   </>

//                   {form.customerType === "รายชิ้น" && (
//                     <>
//                       <Row>
//                         <Col lg="6">
//                           <FormGroup>
//                             <label
//                               className="form-control-label"
//                               htmlFor="input-last-name"
//                             >
//                               ชื่อบริการ
//                             </label>
//                             <Input
//                               className="form-control-alternative"
//                               id="input-name"
//                               type="text"
//                               value={form.name}
//                               onChange={(e) =>
//                                 setForm((s) => ({ ...s, name: e.target.value }))
//                               }
//                             />
//                           </FormGroup>
//                         </Col>
//                       </Row>
//                       <Row>
//                         <Col lg="12">
//                           <label className="form-control-label">หน่วย</label>
//                           <FormGroup className="mb-0">
//                             <UnitChooser />
//                           </FormGroup>
//                         </Col>
//                       </Row>
//                     </>
//                   )}

//                   {form.customerType === "ชั่งกิโล" && (
//                     <>
//                       <Row>
//                         <Col lg="6">
//                           <FormGroup>
//                             <label
//                               className="form-control-label"
//                               htmlFor="input-last-name"
//                             >
//                               ชื่อแพ็คเเกจ
//                             </label>
//                             <Input
//                               className="form-control-alternative"
//                               id="input-name"
//                               type="text"
//                               value={form.name}
//                               onChange={(e) =>
//                                 setForm((s) => ({ ...s, name: e.target.value }))
//                               }
//                             />
//                           </FormGroup>
//                         </Col>
//                         <Col lg="6">
//                           <FormGroup>
//                             <label
//                               className="form-control-label"
//                               htmlFor="input-last-name"
//                             >
//                               จำนวน
//                             </label>
//                             <Input
//                               className="form-control-alternative"
//                               id="input-qty"
//                               type="number"
//                               value={form.qty}
//                               onChange={(e) =>
//                                 setForm((s) => ({ ...s, qty: e.target.value }))
//                               }
//                             />
//                           </FormGroup>
//                         </Col>
//                         <Col lg="6">
//                           <FormGroup>
//                             <label
//                               className="form-control-label"
//                               htmlFor="input-last-name"
//                             >
//                               ราคา(บาท)
//                             </label>
//                             <Input
//                               className="form-control-alternative"
//                               id="input-price"
//                               type="number"
//                               value={form.price}
//                               onChange={(e) =>
//                                 setForm((s) => ({
//                                   ...s,
//                                   price: e.target.value,
//                                 }))
//                               }
//                             />
//                           </FormGroup>
//                         </Col>
//                         <Col lg="6">
//                           <FormGroup>
//                             <label
//                               className="form-control-label"
//                               htmlFor="input-last-name"
//                             >
//                               ระยะเวลา(วัน)
//                             </label>
//                             <Input
//                               className="form-control-alternative"
//                               id="input-leadtime"
//                               type="number"
//                               value={form.leadtime}
//                               onChange={(e) =>
//                                 setForm((s) => ({
//                                   ...s,
//                                   leadtime: e.target.value,
//                                 }))
//                               }
//                             />
//                           </FormGroup>
//                         </Col>
//                       </Row>
//                       <Row>
//                         <Col lg="12">
//                           <label className="form-control-label">หน่วย</label>
//                           <FormGroup className="mb-0">
//                             <UnitChooser />
//                           </FormGroup>
//                         </Col>
//                       </Row>
//                     </>
//                   )}

//                   {/* Mobile: เลือกทั้งหมด (แสดงเฉพาะจอเล็ก) */}
//                   <div className="select-all-mobile">
//                     <label className="form-control-label">เลือกทั้งหมด</label>
//                     <Input
//                       type="checkbox"
//                       className="round-checkbox"
//                       checked={allChecked}
//                       onChange={toggleAll}
//                       aria-label="เลือกทั้งหมด"
//                     />
//                   </div>
//                   <div className="table-responsive">
//                     <Table
//                       hover
//                       className="table table-modern mb-0 mt-3 product-table"
//                     >
//                       <thead className="thead-colored">
//                         <tr>
//                           <th className="checkbox-col">
//                             <div className="th-center">
//                               <Input
//                                 type="checkbox"
//                                 className="round-checkbox"
//                                 checked={allChecked}
//                                 onChange={toggleAll}
//                                 aria-label="เลือกทั้งหมด"
//                               />
//                             </div>
//                           </th>

//                           <th scope="col">รหัสสินค้า</th>
//                           <th scope="col">ชื่อสินค้า</th>
//                           <th scope="col" className="text-end pe-4">
//                             ราคาต่อชิ้น
//                           </th>
//                           <th scope="col" />
//                         </tr>
//                       </thead>

//                       <tbody>
//                         {prodLoading && (
//                           <tr>
//                             <td colSpan={5} className="text-center py-4">
//                               กำลังโหลดสินค้า...
//                             </td>
//                           </tr>
//                         )}

//                         {!prodLoading && prodError && (
//                           <tr>
//                             <td
//                               colSpan={5}
//                               className="text-center text-danger py-4"
//                             >
//                               {prodError}
//                             </td>
//                           </tr>
//                         )}

//                         {!prodLoading &&
//                           !prodError &&
//                           products.length === 0 && (
//                             <tr>
//                               <td colSpan={5} className="text-center py-4">
//                                 ไม่พบสินค้า
//                               </td>
//                             </tr>
//                           )}

//                         {!prodLoading &&
//                           !prodError &&
//                           paginatedProducts.map((p) => (
//                             <tr key={p.pdId}>
//                               <td>
//                                 <Input
//                                   type="checkbox"
//                                   className="round-checkbox"
//                                   checked={selected.has(p.pdId)}
//                                   onChange={() => toggleSelect(p.pdId)}
//                                   aria-label={`เลือก ${p.pdName}`}
//                                 />
//                               </td>
//                               <td data-th="รหัสสินค้า">{p.pdCode}</td>
//                               <td data-th="ชื่อสินค้า">{p.pdName}</td>
//                               <td data-th="ราคาต่อชิ้น">
//                                 {Number(p.pdPrice ?? 0)}
//                               </td>
//                               <td />
//                             </tr>
//                           ))}
//                       </tbody>
//                     </Table>
//                   </div>

//                   <div className="d-flex justify-content-between align-items-center mt-4">
//                     {/* ตัวนับด้านซ้าย (หรือย้ายไปขวาก็ได้) */}
//                     <div className="text-muted small">
//                       {products.length
//                         ? `แสดงสินค้า ${start}-${end} จากทั้งหมด ${products.length} รายการ`
//                         : `ไม่พบรายการ`}
//                     </div>

//                     {/* Pagination */}
//                     <nav aria-label="Page navigation">
//                       <Pagination className="mb-0">
//                         <PaginationItem disabled={currentPage === 1}>
//                           <PaginationLink
//                             href="#"
//                             onClick={(e) => {
//                               e.preventDefault();
//                               setCurrentPage((p) => Math.max(p - 1, 1));
//                             }}
//                           >
//                             <i className="fas fa-angle-left" />
//                           </PaginationLink>
//                         </PaginationItem>

//                         {Array.from(
//                           { length: totalPages },
//                           (_, i) => i + 1
//                         ).map((page) => (
//                           <PaginationItem
//                             key={page}
//                             active={page === currentPage}
//                           >
//                             <PaginationLink
//                               href="#"
//                               onClick={(e) => {
//                                 e.preventDefault();
//                                 setCurrentPage(page);
//                               }}
//                             >
//                               {page}
//                             </PaginationLink>
//                           </PaginationItem>
//                         ))}

//                         <PaginationItem
//                           disabled={
//                             currentPage === totalPages || totalPages === 0
//                           }
//                         >
//                           <PaginationLink
//                             href="#"
//                             onClick={(e) => {
//                               e.preventDefault();
//                               setCurrentPage((p) =>
//                                 Math.min(p + 1, totalPages)
//                               );
//                             }}
//                           >
//                             <i className="fas fa-angle-right" />
//                           </PaginationLink>
//                         </PaginationItem>
//                       </Pagination>
//                     </nav>
//                   </div>
//                 </Form>
//               </CardBody>
//             </Card>
//           </Col>
//         </Row>
//       </Container>
//       <ModalFooter>
//         <Button color="secondary" onClick={handleCancelAddPackage}>
//           ยกเลิก
//         </Button>
//         <Button color="primary" onClick={handleSubmit} disabled={submitting}>
//           {submitting ? "กำลังบันทึก..." : "บันทึก"}
//         </Button>
//       </ModalFooter>
//     </>
//   );
// };

// export default AddPackage;

import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../auth/AuthContext";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  Container,
  Row,
  Col,
  ModalFooter,
  Label,
  Table,
  CardFooter,
  Pagination,
  PaginationItem,
  PaginationLink,
} from "reactstrap";
// core components
import Header from "components/Headers/Header";
import { api } from "../../config/middleware";
import {
  API_GETUNITS,
  API_GETSERVICES,
  API_ADDSERVICE,
  API_GETPRODUCTS,
} from "../../config/api";
import { useSessionStore } from "../../stores/sessionStore";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const AddPackage = () => {
  const MySwal = withReactContent(Swal);

  const orgId = useSessionStore((s) => s.profile?.orgId);

  const navigate = useNavigate();
  const { user } = useAuth();
  const role = (
    user?.role ||
    localStorage.getItem("role") ||
    "user"
  ).toLowerCase();

  const [logoFile, setLogoFile] = useState(null);
  const [logoPreview, setLogoPreview] = useState("");

  const onLogoChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setLogoFile(file);
    const objectUrl = URL.createObjectURL(file);
    setLogoPreview(objectUrl);
  };

  // cleanup object URL เมื่อเปลี่ยนไฟล์หรือ unmount
  useEffect(() => {
    return () => {
      if (logoPreview) URL.revokeObjectURL(logoPreview);
    };
  }, [logoPreview]);

  // state ฟอร์มอย่างง่าย
  const [form, setForm] = useState({
    zoneId: "",
    customerCode: "",
    name: "",
    qty: "",
    price: "",
    leadtime: "",
    status: "pending",
    users: "",
    completion: 0,
    days: [],
    timeSlot: "",
    packingColor: "#3B82F6",
    customerType: "แพ็คเกจ",
    unitId: "",
    unitName: "",
  });

  const customerTypeOptions = [
    {
      value: "แพ็คเกจ",
      label: "แพ็คเกจ",
    },
    {
      value: "รายชิ้น",
      label: "รายชิ้น",
    },
    {
      value: "ชั่งกิโล",
      label: "ชั่งกิโล",
    },
  ];

  const handleCancelAddPackage = () => {
    navigate("/manage-package");
  };

  // ===== ดึง “สินค้า” จาก API_GETPRODUCTS =====
  const [products, setProducts] = useState([]);
  const [prodLoading, setProdLoading] = useState(false);
  const [prodError, setProdError] = useState("");
  const [selected, setSelected] = useState(new Set()); // เก็บ checkbox ที่เลือก

  useEffect(() => {
    let alive = true;
    const fetchProducts = async () => {
      if (!orgId) return;
      setProdLoading(true);
      setProdError("");
      try {
        const res = await api.get(API_GETPRODUCTS, {
          params: { ORGID: orgId },
        });
        // โครงสร้าง response: { statustext, message, data: [...] }
        const arr = Array.isArray(res?.data?.data) ? res.data.data : [];
        if (alive) setProducts(arr);
      } catch (err) {
        if (alive) setProdError(err?.message || "โหลดสินค้าล้มเหลว");
      } finally {
        if (alive) setProdLoading(false);
      }
    };
    fetchProducts();
    return () => {
      alive = false;
    };
  }, [orgId]);

  const toggleSelect = (id) =>
    setSelected((prev) => {
      const next = new Set(prev);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });

  const allChecked = products.length > 0 && selected.size === products.length;
  const toggleAll = () =>
    setSelected((prev) =>
      prev.size === products.length
        ? new Set()
        : new Set(products.map((p) => p.pdId)),
    );

  // ===== ดึง “หน่วย” จาก API_GETSERVICES =====
  const [units, setUnits] = useState([]);
  const [unitLoading, setUnitLoading] = useState(false);
  const [unitError, setUnitError] = useState("");

  useEffect(() => {
    let alive = true;
    const fetchUnits = async () => {
      if (!orgId) return;
      setUnitLoading(true);
      setUnitError("");
      try {
        const res = await api.get(API_GETUNITS, {
          params: { ORGID: orgId },
        });
        const arr = Array.isArray(res?.data?.data) ? res.data.data : [];
        if (alive)
          setUnits(arr.map((u) => ({ id: u.unitId, name: u.unitName })));
      } catch (err) {
        if (alive) setUnitError(err?.message || "โหลดหน่วยไม่สำเร็จ");
      } finally {
        if (alive) setUnitLoading(false);
      }
    };
    fetchUnits();
    return () => {
      alive = false;
    };
  }, [orgId]);

  // === ปุ่มเลือก “หน่วย” แบบเม็ดยา ===
  const UnitChooser = () => {
    if (unitError) return <div className="text-danger">{unitError}</div>;

    return (
      <div className="d-flex align-items-center flex-wrap">
        {units.map((u) => {
          const active = form.unitId === u.id;
          return (
            <Button
              key={u.id}
              type="button"
              size="sm"
              outline={!active}
              color={active ? "primary" : "secondary"}
              className="mr-2 mb-2 rounded-pill"
              onClick={() =>
                setForm((s) => ({ ...s, unitId: u.id, unitName: u.name }))
              }
              aria-pressed={active}
            >
              {u.name}
            </Button>
          );
        })}

        {/* เก็บค่าไว้ตอน submit */}
        <Input type="hidden" name="unitId" value={form.unitId || ""} />
        <Input type="hidden" name="unitName" value={form.unitName || ""} />
      </div>
    );
  };

  const [submitting, setSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState("");

  const handleSubmit = async () => {
    try {
      setSubmitting(true);
      setSubmitError("");

      // ตรวจขั้นต่ำ
      if (!orgId) throw new Error("ไม่พบ ORGID");
      if (!form.name?.trim()) throw new Error("กรุณากรอกชื่อแพ็คเกจ/บริการ");
      if (!form.unitName) throw new Error("กรุณาเลือกหน่วย");

      const payload = {
        ORGID: orgId,
        NAME: form.name?.trim(),
        PRICE: Number(form.price || 0),
        TYPE: form.customerType,
        QTY: Number(form.qty || 0),
        LEADTIME: Number(form.leadtime || 0),
        UNIT: form.unitName,
        PRODUCT: products.filter((p) => selected.has(p.pdId)),
      };

      await api.post(API_ADDSERVICE, payload);

      await MySwal.fire({
        icon: "success",
        title: "บันทึกสำเร็จ",
        timer: 1500,
        showConfirmButton: false,
      });

      navigate("/manage-package");
    } catch (err) {
      setSubmitError(err?.message || "บันทึกไม่สำเร็จ");
    } finally {
      setSubmitting(false);
    }
  };

  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 10;
  const totalPages = Math.ceil(products.length / pageSize);

  const paginatedProducts = products.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize,
  );

  const start = products.length ? (currentPage - 1) * pageSize + 1 : 0;
  const end = Math.min(currentPage * pageSize, products.length);

  return (
    <>
      <Header />
      {/* Page content */}
      <Container className="mt--7" fluid>
        <Row>
          <Col xs="12">
            <Card className="bg-secondary shadow">
              <CardHeader className="bg-white border-0">
                <Row className="align-items-center">
                  <Col xs="8">
                    <h6 className="mb-0">เพิ่มบริการ</h6>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <Form>
                  <>
                    <Row>
                      <Col lg="12">
                        <FormGroup>
                          {customerTypeOptions.map((o) => {
                            const active = form.customerType === o.value;
                            return (
                              <Button
                                key={o.value}
                                type="button"
                                size="sm"
                                outline={!active}
                                color={active ? "primary" : "secondary"}
                                className="mr-2 mb-2 rounded-pill"
                                onClick={() =>
                                  setForm((s) => ({
                                    ...s,
                                    customerType: o.value,
                                  }))
                                }
                                aria-pressed={active}
                              >
                                {o.label}
                              </Button>
                            );
                          })}
                          <Input
                            type="hidden"
                            name="customerType"
                            value={form.customerType}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    {form.customerType === "แพ็คเกจ" && (
                      <>
                        <Row>
                          <Col lg="6">
                            <FormGroup>
                              <label
                                className="form-control-label"
                                htmlFor="input-last-name"
                              >
                                ชื่อแพ็คเเกจ
                              </label>
                              <Input
                                className="form-control-alternative"
                                id="input-name"
                                type="text"
                                value={form.name}
                                onChange={(e) =>
                                  setForm((s) => ({
                                    ...s,
                                    name: e.target.value,
                                  }))
                                }
                              />
                            </FormGroup>
                          </Col>
                          <Col lg="6">
                            <FormGroup>
                              <label
                                className="form-control-label"
                                htmlFor="input-last-name"
                              >
                                จำนวน
                              </label>
                              <Input
                                className="form-control-alternative"
                                id="input-qty"
                                type="number"
                                value={form.qty}
                                onChange={(e) =>
                                  setForm((s) => ({
                                    ...s,
                                    qty: e.target.value,
                                  }))
                                }
                              />
                            </FormGroup>
                          </Col>
                          <Col lg="6">
                            <FormGroup>
                              <label
                                className="form-control-label"
                                htmlFor="input-last-name"
                              >
                                ราคา(บาท)
                              </label>
                              <Input
                                className="form-control-alternative"
                                id="input-price"
                                type="number"
                                value={form.price}
                                onChange={(e) =>
                                  setForm((s) => ({
                                    ...s,
                                    price: e.target.value,
                                  }))
                                }
                              />
                            </FormGroup>
                          </Col>
                          <Col lg="6">
                            <FormGroup>
                              <label
                                className="form-control-label"
                                htmlFor="input-last-name"
                              >
                                ระยะเวลา(วัน)
                              </label>
                              <Input
                                className="form-control-alternative"
                                id="input-leadtime"
                                type="number"
                                value={form.leadtime}
                                onChange={(e) =>
                                  setForm((s) => ({
                                    ...s,
                                    leadtime: e.target.value,
                                  }))
                                }
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg="12">
                            <label className="form-control-label">หน่วย</label>
                            <FormGroup className="mb-0">
                              <UnitChooser />
                            </FormGroup>
                          </Col>
                        </Row>
                      </>
                    )}
                  </>

                  {form.customerType === "รายชิ้น" && (
                    <>
                      <Row>
                        <Col lg="6">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-last-name"
                            >
                              ชื่อบริการ
                            </label>
                            <Input
                              className="form-control-alternative"
                              id="input-name"
                              type="text"
                              value={form.name}
                              onChange={(e) =>
                                setForm((s) => ({ ...s, name: e.target.value }))
                              }
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="12">
                          <label className="form-control-label">หน่วย</label>
                          <FormGroup className="mb-0">
                            <UnitChooser />
                          </FormGroup>
                        </Col>
                      </Row>
                    </>
                  )}

                  {form.customerType === "ชั่งกิโล" && (
                    <>
                      <Row>
                        <Col lg="6">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-last-name"
                            >
                              ชื่อแพ็คเเกจ
                            </label>
                            <Input
                              className="form-control-alternative"
                              id="input-name"
                              type="text"
                              value={form.name}
                              onChange={(e) =>
                                setForm((s) => ({ ...s, name: e.target.value }))
                              }
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="6">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-last-name"
                            >
                              ราคา (บาท)
                            </label>
                            <Input
                              className="form-control-alternative"
                              id="input-price"
                              type="number"
                              value={form.price}
                              onChange={(e) =>
                                setForm((s) => ({
                                  ...s,
                                  price: e.target.value,
                                }))
                              }
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="6">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-last-name"
                            >
                              ระยะเวลา (วัน)
                            </label>
                            <Input
                              className="form-control-alternative"
                              id="input-leadtime"
                              type="number"
                              value={form.leadtime}
                              onChange={(e) =>
                                setForm((s) => ({
                                  ...s,
                                  leadtime: e.target.value,
                                }))
                              }
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="6">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-last-name"
                            >
                              จำนวน
                            </label>
                            <Input
                              className="form-control-alternative"
                              id="input-qty"
                              type="number"
                              value={form.qty}
                              onChange={(e) =>
                                setForm((s) => ({ ...s, qty: e.target.value }))
                              }
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="12">
                          <label className="form-control-label">หน่วย</label>
                          <FormGroup className="mb-0">
                            <UnitChooser />
                          </FormGroup>
                        </Col>
                      </Row>
                    </>
                  )}
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      <ModalFooter>
        <Button color="secondary" onClick={handleCancelAddPackage}>
          ยกเลิก
        </Button>
        <Button color="primary" onClick={handleSubmit} disabled={submitting}>
          {submitting ? "กำลังบันทึก..." : "บันทึก"}
        </Button>
      </ModalFooter>
    </>
  );
};

export default AddPackage;
